<template>
    <div>
        <order-write-link v-for="writeLayout in writeLayouts" :key="`order${writeLayout}`"
                          :writeLayout="writeLayout" :orderTitle="orderTitle" :memo="memo"></order-write-link>
    </div>
</template>

<script>
import OrderWriteLink from "./link/OrderWriteLink";
import orderUtil from "./orderUtil";
import alertMixins from "../../mixins/alertMixins";
import util from "../../mixins/util";
import EventBus from "../../mixins/event-bus";
import orderValidator from "./orderValidator";
export default {
    name: "OrderWriteComponent",
    components: {OrderWriteLink},
    mixins: [orderUtil,alertMixins,orderValidator],
    inject: [],
    provide() {
        return {
            orderWriteSetData: this.setData,
        }
    },
    props: {
        orderType : '',
        orderKey : {default: 0},
        memo : {default: ''},
    },
    data() {
        return {
            writeFunc: '',
            writeLayouts: [],
            writeApiParamSet: {},
            isRunning: false,
            parsingData: {},
            writeSuccessType: 1,
            writeFailTypes: {},
            writeFailMsg: '',
            keyName : '',
            orderTitle : '',
            getFunc : '',
            detailApiParamSet :{},
            redirectType:'',
            closeModalName:'',

            orderData : {},
            failCnt : 0,
            requestCnt: 0,

        }
    },
    created() {
        this.initFilterConfig();

    },
    mounted() {
        EventBus.$on('runWrite',this.runWrite)
        EventBus.$on('multipleWrite',this.checkMultiple)
    },
    beforeDestroy() {
        EventBus.$off('runWrite')
        EventBus.$off('multipleWrite')
    },
    destroyed() {
    },
    computed: {},
    methods: {
        setData(type, value) {
            this[type] = value;
        },
        initTemplateConfig(){
            let config = this.returnOrderConfig(this.orderType);
            this.writeLayouts = config.writeLayouts;
        },
        initFilterConfig(){
            let config = this.returnOrderConfig(this.orderType);
            this.getFunc = config.getFunc;
            this.detailApiParamSet = config.detailApiParamSet;
            this.writeFunc = config.writeFunc;
            this.writeApiParamSet = config.writeApiParamSet;
            this.writeSuccessType = config.writeSuccessType;
            this.writeFailTypes = config.writeFailTypes;
            this.writeFailMsg = config.writeFailMsg;
            this.parsingData = config.parsingData;
            this.keyName = config.keyName;
            this.orderTitle = config.orderTitle;

            this.redirectType = config.redirectType
            this.closeModalName = config.closeModalName

            this.initTemplateConfig()
        },

        _checkValidator() {
            let validatorArr = Object.keys(this.parsingData);

            return this.$validate(validatorArr).then(success => {
                if (!success) {
                    this.errorAlert('필수데이터를 확인해주세요.')
                    util.Array.each(this.writeLayouts, (layout, index, arr) => {
                        EventBus.$emit(`${layout}Validator`, validatorArr);
                    });
                    return success
                }
                return success;
            })
        },
        _makeParams() {
            let params = Object.assign({}, this.writeApiParamSet);
            util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
                if(this[dataKey] !== ''){
                    params[paramKey] = this[dataKey];
                }
            })
            if (this.orderKey !== 0) {
                params[this.keyName] = this.orderKey;
            }
            return params;
        },
        async runWrite(){
            let validator = await this._checkValidator();
            if (!validator) {
                EventBus.$emit('changeLoading', false);
                return false;
            }
            EventBus.$emit('changeLoading', true);
            let params = this._makeParams();

            try {
                this.$api.$order[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    let type = this.returnWriteType(res.List.Data.Status);
                    if (type === true) {
                        this.afterFunc();
                    } else {
                        this.errorAlert(type);
                        EventBus.$emit('changeLoading', false);
                    }
                })
            } catch (e) {
                console.log(e)
                EventBus.$emit('changeLoading', false);
            }
        },
        returnWriteType(type) {
            if (type === this.writeSuccessType) {
                return true;
            } else {
                return util.isEmpty(this.writeFailTypes[type]) ? this.writeFailMsg : this.writeFailTypes[type];
            }
        },
        afterFunc(){
            EventBus.$emit('changeLoading', false);
            this.createAlert({
                content: '저장하였습니다.',
                hide: () => {
                    this.hideAlert();
                }
            })
        },
        hideAlert() {
            if(!util.isEmpty(this.closeModalName)){
                // 모달 이름 선언했을 경우 모달 닫고
                this.$modal.hide(this.closeModalName)
            }
            if(this.redirectType === 'back'){
                // 상세일 경우
                this.$router.back()
            }else if(this.redirectType === 'reset'){
                // 리스트 일 경우
                EventBus.$emit('resetOrderData')
            }
        },
        checkMultiple(arr){
            let listCnt = arr.length
            EventBus.$emit('changeLoading', true);
            util.Array.each(arr, (key, index, arr) => {
                this.multipleWrite(key.c_idx, key.c_status, listCnt)
            })
        },
        checkMultipleResult(listCnt){
            if(this.failCnt > 0){
                if(listCnt !== 1 && this.failCnt < listCnt){
                    EventBus.$emit('changeLoading', false);
                    this.errorAlert('일부 항목의 상태 변경에 실패했습니다.')
                    this.hideAlert();
                }else{
                    EventBus.$emit('changeLoading', false);
                    this.errorAlert('상태 변경에 실패했습니다.')
                    this.hideAlert();
                }
            }else{
                this.afterFunc()
            }
        },
        _makeMultipleParams(){
            let params = Object.assign({}, this.writeApiParamSet);
            util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
                params[paramKey] = this[dataKey];
            })
            return params;
        },
        async multipleWrite(key,status, listCnt){
            let validator = await this._checkValidator();
            if (!validator) {
                EventBus.$emit('changeLoading', false);
                return false;
            }
            let params = this._makeMultipleParams();
            params.c_idx = key
            params.c_status = status

            try {
                this.$api.$order[this.writeFunc](params).then(res => res.Data.Result).then(res => {
                    this.requestCnt +=1;
                    if(!util.isEmpty(res.List.Data)){
                        let type = this.returnMultipleWriteType(res.List.Data.Status);
                        if (type !== true) {
                            this.failCnt += 1
                        }
                    }else{
                        this.failCnt += 1
                    }
                    if(this.requestCnt == listCnt) {
                        this.checkMultipleResult(listCnt);
                    }
                })
            } catch (e) {
                this.failCnt += 1
                console.log(e)
                EventBus.$emit('changeLoading', false);
            }
        },
        returnMultipleWriteType(type){
            switch (type) {
                case true :
                    return true
                default :
                    return '상태 변경에 실패했습니다.'

            }
        }

    },
    watch: {},
}
</script>

<style scoped>

</style>
